import LayerIcon from '@/../img/layer-icon.svg';
import RefocusIcon from '@/../img/refocus-icon.svg';
import Camera from '@/../img/screenshot.svg';
import mapDefaultStyleIcon from '@/../img/terrain-icon-default.png';
import mapSatelliteStyleIcon from '@/../img/terrain-icon-satellite.png';
import ZoningIcon from '@/../img/zoning-icon.svg';
import {
  MAPBOX_DEFAULT_STYLE,
  MAPBOX_SATELLITE_STYLE,
} from '@/../shared-constants/map-constants';
import { MapboxInstanceMgr } from '@/map/map-instance';
import { useState } from 'react';
import {
  BottomMapButton,
  MapLayerButton,
  StandAloneButton,
  StyledMapButtonImg,
  StyledRefocusButton,
  TopMapButton,
} from './map-control-styles';

const mapStyleBackgroundImages = {
  [MAPBOX_SATELLITE_STYLE]: mapSatelliteStyleIcon,
  [MAPBOX_DEFAULT_STYLE]: mapDefaultStyleIcon,
};

function MoreOptionsToggleButton(props) {
  const { onClick, layerCtrlsOpen } = props;
  return (
    <MapLayerButton
      data-cy="map-layer-btn"
      className="mapboxgl-ctrl"
      onClick={onClick}
      title="More options"
      layerCtrlsOpen={layerCtrlsOpen}
    >
      <LayerIcon />
    </MapLayerButton>
  );
}

function RefocusButton(props) {
  const { onClick } = props;
  return (
    <StyledRefocusButton
      data-cy="refocus-btn"
      className="mapboxgl-ctrl"
      onClick={onClick}
      title="Refocus button"
    >
      <RefocusIcon />
    </StyledRefocusButton>
  );
}

function TerrainToggleButton(props) {
  const { layerCtrlsOpen, hasZoningFile } = props;
  const [currentMapStyle, setCurrentMapStyle] = useState(
    MAPBOX_SATELLITE_STYLE
  );
  const MapStyleButton = hasZoningFile ? TopMapButton : StandAloneButton;

  return (
    <MapStyleButton
      data-cy="terrain-toggle-btn"
      className="mapboxgl-ctrl"
      onClick={() => {
        MapboxInstanceMgr.getInstance().toggleStyle();
        setCurrentMapStyle(MapboxInstanceMgr.getInstance().getStyleName());
      }}
      title="Toggle view style"
    >
      <StyledMapButtonImg
        data-cy="styled-map-btn-img"
        layerCtrlsOpen={layerCtrlsOpen}
        src={mapStyleBackgroundImages[currentMapStyle]}
      />
    </MapStyleButton>
  );
}

function ZoningToggleButton(props) {
  const { onClick } = props;
  return (
    <BottomMapButton
      data-cy="zoning-toggle-btn"
      className="mapboxgl-ctrl"
      onClick={onClick}
      title="Show zoning areas"
    >
      <ZoningIcon />
    </BottomMapButton>
  );
}

function MapSnapshotButton(props) {
  const { onClick } = props;
  return (
    <StandAloneButton
      data-cy="map-snap-btn"
      className="mapboxgl-ctrl"
      onClick={onClick}
      title="Snapshot Map"
    >
      <Camera />
    </StandAloneButton>
  );
}

export {
  MapSnapshotButton,
  MoreOptionsToggleButton,
  RefocusButton,
  TerrainToggleButton,
  ZoningToggleButton,
};
